import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fb7d0ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot dot-separator" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot dot-separator" }, null, -1));
const _hoisted_5 = [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
];
export default /*#__PURE__*/ _defineComponent({
    __name: 'MenuDots',
    emits: ['click'],
    setup(__props, { emit }) {
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: "w-4",
                onClick: _withModifiers(handleClick, ["prevent"])
            }, _hoisted_5, 8, _hoisted_1));
        };
    }
});
